import React from 'react';
import classNames from 'classnames';
import {Avatar, SkeletonThumbnail} from '@shopify/polaris';

import styles from './ProfileImage.scss';

type Size = 'Small' | 'Large';

interface ProfileImage {
  source: string;
  size?: Size;
  accessibilityLabel?: string;
}

export default function ProfileImage({
  source,
  size = 'Small',
  accessibilityLabel,
}: ProfileImage) {
  return (
    <div className={classNames(styles.ProfileImage, styles[size])}>
      <Avatar source={source} accessibilityLabel={accessibilityLabel} />
    </div>
  );
}

export function SkeletonProfileImage({size = 'Small'}: {size?: Size}) {
  return (
    <div
      className={classNames(
        styles.ProfileImage,
        styles.SkeletonImage,
        styles[size]
      )}
    >
      <SkeletonThumbnail />
    </div>
  );
}
